module.exports = __webpack_public_path__ + "img/img_video.1f0dc058.png";